import { z } from 'zod';
import { defineEndpoint } from '../define';
import { GitRefSchema } from './git-branches';

/** Latest 10 tags, filtered by `q` substring when given. */
export const listGitTags = defineEndpoint({
  method: 'GET',
  path: '/v1/release-products/:productId/git/tags',
  params: z.object({ productId: z.string().uuid() }),
  query: z.object({ q: z.string().optional() }),
  body: z.undefined(),
  response: z.object({ data: z.array(GitRefSchema) }),
});
